import { FC, useContext, useEffect, useMemo } from 'react';
import { createGQLDataContext } from 'utils/createDataContext';
import { useGQLQuery } from 'hooks';
import { ContinueCalloutDialogQuery, ContinueCalloutDialogQueryVariables } from 'types/graphql';
import { GQLAPIContextType } from 'types/common.types';
import {
  continueCalloutDialogConfig,
  ContinueCalloutDialogData,
} from 'components/ContinueCalloutDialog/ContinueCalloutDialog.constants';

export const ContinueCalloutDialogDataContext =
  createGQLDataContext<GQLAPIContextType<ContinueCalloutDialogQuery>>();

export const ContinueCalloutDialogDataProvider: FC<{ orderRelayId: string }> = ({
  children,
  orderRelayId,
}) => {
  const { data, fetch, ...restQuery } = useGQLQuery<
    ContinueCalloutDialogQuery,
    ContinueCalloutDialogData,
    ContinueCalloutDialogQueryVariables
  >(continueCalloutDialogConfig(orderRelayId));

  useEffect(() => {
    fetch();
  }, []); // eslint-disable-line

  const contextValues = useMemo(() => {
    const order = data?.order;
    return {
      calloutListId: order?.currentlyActiveCalloutList?.id,
      isAllowOvertime: !!order?.allowOvertime,
      nextGroupName: order?.currentlyActiveCalloutList?.manualApprovalIndexes?.[0]?.groupName,
      data,
      fetch,
      ...restQuery,
    };
  }, [data, fetch, restQuery]);

  return (
    <ContinueCalloutDialogDataContext.Provider value={contextValues}>
      {children}
    </ContinueCalloutDialogDataContext.Provider>
  );
};

export const useContinueCalloutDialogDataContext =
  (): GQLAPIContextType<ContinueCalloutDialogQuery> => useContext(ContinueCalloutDialogDataContext);
